<template>
    <VRadio v-bind="$attrs" :class="classList">
        <template #label>
            <slot name="label" />
        </template>
    </VRadio>
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

const ELEMENT_CLASS = 'sr-radio-button';

export default {
    name: 'SrRadioButton',
    computed: {
        classList() {
            return [ELEMENT_CLASS, USER_INPUT_CLASS];
        },
    },
};
</script>

<style lang="scss" scoped>
.v-radio {
    width: fit-content;
}
</style>
